import 'core-js'
import 'regenerator-runtime/runtime'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { i18nClient, MCity } from '@sailor/i18n-web'
import ChainedBackend from 'i18next-chained-backend'
import OpenAPIBackend from '@sailor/i18n-web-openapi-backend'
import resourcesToBackend from 'i18next-resources-to-backend'
import resources from './locales/resources'
import Root from './Root'
import { isProd, getI18nParams, defaultLang } from '@RootCommon/utils'
import locale from '@roo/roo/locale'
import zhHK from '@roo/roo/locale/lang/zh-TW'
import zh from '@roo/roo/locale/lang/zh-CN'
import en from '@roo/roo/locale/lang/en-US'
import ar from '@roo/roo/locale/lang/ar'
import ptBR from '@roo/rooNew/locale/lang/pt-BR'
import locale_plus from '@roo/roo-plus/locale'
import locale_new from '@roo/rooNew/locale'
import zhHK_plus from '@roo/roo-plus/locale/lang/zh-TW'
import zh_plus from '@roo/roo-plus/locale/lang/zh-CN'
import en_plus from '@roo/roo-plus/locale/lang/en-US'
import ar_plus from '@roo/roo-plus/locale/lang/ar'
import { configResponsive } from '@RootCommon/utils/h5PC'
import responsiveConfig from './common/constants/mediaBreakPoint.json'
import dayjs from 'dayjs'
import i18nConfig from '../.i18n.config.json'
import '@roo/roo/theme/default/index.css'
import '@roo/roo-plus/theme/default/index.css'
import ConfigProvider from '@roo/rooNew/ConfigProvider'
import { initPerformanceReport } from '@/common/utils/performanceReport'

// 初始化性能指标采集和上报
initPerformanceReport()

const region = getI18nParams()?.region
if (window.H5guard && window.H5guard?.setRegion) {
  window.H5guard.setRegion(region)
}

const i18nEnv = isProd() ? 'prod' : 'test'
const rooLocaleLangs = {
  'zh-HK': zhHK,
  zh: zh,
  en: en,
  ar: ar,
  'pt-BR': ptBR,
}
const rooPlusLocaleLangs = {
  'zh-HK': zhHK_plus,
  zh: zh_plus,
  en: en_plus,
  ar: ar_plus,
  'pt-BR': ptBR,
}
configResponsive(responsiveConfig)

try {
  if (/^(ar|fa|ur|he)/.test(defaultLang)) document?.documentElement?.setAttribute('dir', 'rtl')
} catch (error) {
  // 不做处理
}

dayjs.locale(defaultLang) // dayjs的语言名可能不一致

locale.use(rooLocaleLangs[defaultLang])
locale_plus.use(rooPlusLocaleLangs[defaultLang])
locale_new.use(rooLocaleLangs[defaultLang])

i18nClient.use(ChainedBackend).init(
  {
    // 设置回退语言
    fallbackLng: 'en',
    ns: i18nConfig.namespaces.map((v: any) => v.name), // 当使用多个空间名称时，必须配置 ns，且第一个为默认空间名
    defaultNS: i18nConfig.namespaces.map((v: any) => v.name)[0], // 设置默认空间名称
    backend: {
      // @ts-ignore
      openI18nKeyRaptor: true,
      i18nKeyRaptorConfig: {
        // i18nKeyRaptorConfig：web 端上报相关配置
        // web 项目参数
        clientAppkey: 'com.sankuai.sailorfe.d.pc', // 项目 appkey，
        region,
      },
      backends: [
        OpenAPIBackend, // 通过api获取最新语言包
        resourcesToBackend(resources), // 本地资源包作为兜底
      ],
      // @ts-ignore
      useSailorCompass: true,
      // @ts-ignore
      idc: process_env_publishIdc,
      autoFetchI18nApiConfig: true,
      // 这里配置一下所使用的projectId和namespaceId
      backendOptions: [{ ...i18nConfig, env: i18nEnv }],
      // @ts-ignore
      cacheOptions: {
        openClearOldLanguagePackage: true,
      },
    },
  },
  function () {
    // 回调中初始化App，并配合lazy的模块才能使用ReactNode外的i18n常量
    // TODO: StrictMode严格模式为其后代 元素触发额外的检查和报告,
    // 在开发过程中组件会有多次调用问题，但仅在开发环境中运行，不会影响生产构建
    createRoot(document.getElementById('root') as HTMLElement).render(
      <ConfigProvider config={{ direction: defaultLang === 'ar' ? 'RTL' : 'LTR' }}>
        <Root />
      </ConfigProvider>,
    )
  },
)

const cityId = MCity.getCapitalCityIdByRegion(region)
window.LXAnalytics?.('setCompass', JSON.stringify({ region, cityId }))
